import { jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useSharedRef } from '../hooks/use-shared-ref.js';
import { mergeStyles } from '../utils/merge-props.js';
import { useIsTruncated, useOnTruncationChange, useTooltip } from './text.hooks.js';
import { parseTruncate, LTR_MARK, baseClassName } from './text.utils.js';
import { truncates, lineClampVar } from './text.css.js';

/**
 * Truncating Text element: single-line (end / start) or multi-line line-clamp. Wires up
 * overflow detection, tooltip-when-truncated, and `onTruncationChange`.
 */
// eslint-disable-next-line react/display-name -- internal helper, not exposed in public API
const TruncatedText = forwardRef(({ as, variant, color = 'inherit', align, italic, underline, strikethrough, truncate, hideTooltip, onTruncationChange, className, style, children, onPointerEnter: onPointerEnterIn, ...props }, refIn) => {
    const ref = useSharedRef(refIn);
    const { mode, lineClamp } = parseTruncate(truncate);
    const isTruncated = useIsTruncated(ref);
    useOnTruncationChange(isTruncated, onTruncationChange);
    const { tooltipProps, onPointerEnter } = useTooltip(isTruncated, hideTooltip, children, onPointerEnterIn);
    // Inject the line-clamp count via CSS var so we don't need a class per clamp value.
    const truncateStyle = lineClamp != null ? { [lineClampVar]: lineClamp } : undefined;
    const Element = as;
    return (jsxs(Element, { "data-fpl-component": "", ...props, ref: ref, className: baseClassName({ variant, color, align, italic, underline, strikethrough }, mode && truncates[mode], className), style: mergeStyles(truncateStyle, style), onPointerEnter: onPointerEnter, ...tooltipProps, children: [children, mode === 'start' ? LTR_MARK : null] }));
});

export { TruncatedText };
//# sourceMappingURL=text.truncated.js.map
